export default "__VITE_ASSET__cRSIS1Li__"